export const WHITE = `#FFFFFF`;
export const SMOKE = `#6F6F6F`;
export const CHARCOAL = `#272727`;
export const DARK_SKY = `#151515`;
export const LASER_BLUE = `#1BE7FF`;
export const SEA_FOAM = `#2CEFBC`;
export const EEL = `#2EF070`;

export const EXTRA_LARGE = `75rem`;
export const LARGE = `62rem`;
export const TABLET = `48rem`;
export const MOBILE = `36rem`;

const theme = {
  AppLink: `

  `,
  Logo: `
  `,
  BodyText: `
    font-family: Roboto, sans-serif;
    color: ${WHITE};
    line-height: 1.875rem;
    font-family: "Roboto";
    weight: 500;
    margin-top: 0;
    a {
      font-weight: bold;
      text-decoration: none;
      border-bottom: solid 2px ${SEA_FOAM};
    }
  `,
  SocialPageButton:`
    :hover {
      background-color: ${EEL};
    }
  `,
  Footer:`
  `,
  CopyShareButton: `

  `,
  EmailShareButton: `

  `,
  FacebookShareButton: `

  `,
  IconButton: `

  `,
  Image: `

  `,
  PinterestShareButton: `

  `,
  TwitterShareButton: `

  `,
  SubTitle: `
    font-family: Roboto;
    font-size: 1.5rem;
    line-height: 2.1875rem;
    font-weight: 700;
    color: ${WHITE};
    margin-bottom: 0;
  `,
  Title: `
    color: ${WHITE};
  `,
  Button: `
    background-color: ${EEL};
    color: ${DARK_SKY};
    border-radius: 3.125rem;
    font-weight: 600;
    min-height: 2.4rem;
    transition: 500ms ease;
    :hover{
      box-shadow: rgba(0, 0, 0, 0.8) 0px 5px 10px 0px;
      background-color: ${EEL};
    }
  `,
};

export default theme;
